<template>
  <v-container fluid>
    <listagem-candidatos :listagemPublica=true></listagem-candidatos>
  </v-container>
</template>
<script>
import ListagemCandidatos from '@/components/ListagemCandidatos.vue';

export default {
  components: {ListagemCandidatos},
  data() {
    return {
      
    };
  }, 
};
</script>
